import { Module, VuexModule, Action } from 'vuex-module-decorators'
import { BroadcastServices } from '../../services/modules/broadcast.service'
import store from '@/store'
import { APIBulkUnsubscription } from '@/models/api/bulk-unsubscription.model'

@Module
export default class BroadcastStore extends VuexModule {
    @Action
    createBroadcast (params: APIBulkUnsubscription) {
        return new Promise((resolve) => {
            if (!params) {
                store.commit('reportError', { code: 1000, statement: 'Something went wrong :(' })
                resolve('')
                return
            }
            const data = Object.assign({}, params)
            BroadcastServices.createBroadcast(data)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
